var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":"","fill-height":""}},[_vm._v(" DASHBOARD ADMIN ")])}
var staticRenderFns = []

export { render, staticRenderFns }